// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"325":"eb8f1243c05ef65d","803":"7d9cfb69971cafcc","888":"e71287c3bfa752ea"}[chunkId] + ".js";
};